import { Box, Typography } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';
import { useGridRootProps } from '@mui/x-data-grid-premium';

/**
 * A stable placeholder overlay component displayed when the dataset resolves to zero records.
 */
export const CustomEmptyOverlay = () => {
  const rootProps = useGridRootProps();

  const isLoading = rootProps['data-is-loading'] === true;
  const firstRender = rootProps['data-first-render'] === true;

  if (isLoading || firstRender || rootProps.loading) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        gap: 1,
        color: '#94a3b8'
      }}>
      <InboxIcon sx={{ fontSize: 40, color: '#cbd5e1' }} />
      <Typography
        sx={{
          fontFamily: 'Roboto, sans-serif',
          fontSize: '0.9rem',
          fontWeight: 500
        }}>
        Nessun elemento disponibile in tabella
      </Typography>
    </Box>
  );
};
